<template>
    <Modal :show-footer="false" :show-title="false" @cancel="close">
        <div class="limited-modal">
            <div class="limited-modal-title">
                <span class="material-icons alert-icon">warning</span>
                Hizmetiniz Askıya Alındı
                <div style="font-size: 16px;margin-top: 10px;">
                    Kullanım ve Paket Uyuşmazlığı
                </div>
            </div>
            <div class="limited-modal-description">
                <div class="limited-modal-description-text">
                    Kullanımınız mevcut paketinizle uyuşmadığı için hesabınız geçici olarak askıya alınmıştır. Kullanıma
                    devam edebilmek için lütfen aşağıdaki güncellemeleri yapınız:
                </div>
                <div class="limited-modal-description-content">
                    <div class="information-detail" v-if="shouldSelectPlan.enabled">
                        <div class="information-detail-text">
                            <b>Gerekli Eklemeler:</b>

                            <div class="information-detail-text-items">
                                <!-- Kullanıcı Kontrolü -->
                                <div v-if="shouldSelectPlan.supsisPackage">
                                    {{ shouldSelectPlan.details.current.users - shouldSelectPlan.details.limit.currentSupsisAgentCount
                                    }}
                                    Temsilci Satın Almalısınız (Mevcut: {{ shouldSelectPlan.details.current.users
                                    }}/Limit:
                                    {{ shouldSelectPlan.details.limit.currentSupsisAgentCount }})
                                </div>

                                <!-- WhatsApp QR Kontrolü -->
                                <div v-if="shouldSelectPlan.whatsappQr">
                                    {{ shouldSelectPlan.details.current.whatsappQr - shouldSelectPlan.details.limit.currentWhatsappPlanCount
                                    }}
                                    WhatsApp Kanalı Satın Almalısınız (Mevcut:
                                    {{ shouldSelectPlan.details.current.whatsappQr }}/Limit:
                                    {{ shouldSelectPlan.details.limit.currentWhatsappPlanCount }})
                                </div>

                                <!-- WhatsApp Business Kontrolü -->
                                <div v-if="shouldSelectPlan.whatsappBusiness">
                                    {{ shouldSelectPlan.details.current.whatsappBusinessChannels - shouldSelectPlan.details.limit.currentWhatsappBusinessChannelCount
                                    }}
                                    WhatsApp Business Kanalı Satın Almalısınız (Mevcut:
                                    {{ shouldSelectPlan.details.current.whatsappBusinessChannels }}/Limit:
                                    {{ shouldSelectPlan.details.limit.currentWhatsappBusinessChannelCount }})
                                </div>

                                <!-- Instagram Kontrolü -->
                                <div v-if="shouldSelectPlan.instagram">
                                    {{ shouldSelectPlan.details.current.instagram - shouldSelectPlan.details.limit.instagram
                                    }}
                                    Instagram Kanalı Satın Almalısınız (Mevcut:
                                    {{ shouldSelectPlan.details.current.instagram }}/Limit:
                                    {{ shouldSelectPlan.details.limit.instagram }})
                                </div>

                                <!-- Messenger Kontrolü -->
                                <div v-if="shouldSelectPlan.messenger">
                                    {{ shouldSelectPlan.details.current.messenger - shouldSelectPlan.details.limit.messenger
                                    }}
                                    Messenger Kanalı Satın Almalısınız (Mevcut:
                                    {{ shouldSelectPlan.details.current.messenger }}/Limit:
                                    {{ shouldSelectPlan.details.limit.messenger }})
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="limited-modal-footer" style="margin-top: 30px;">
                        <SupsisButton
                            @click="confirm"
                            primary
                            style="width: 250px;"
                        >
                            Paketlerim Sayfasına Git
                        </SupsisButton>
                        <div style="margin-top: 15px; font-size: 12px; color: #666;">
                            Not: Güncellemeleri tamamladıktan sonra hesabınız otomatik olarak yeniden aktif hale
                            gelecektir.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/common/Modal2.vue";
import { mapGetters } from "vuex";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default {
    name: "LimitedModal",
    components: {
        SupsisButton,
        Modal,
    },
    methods: {
        close() {
            this.$emit("cancel");
        },
        confirm() {
            this.$router.push("/settings/billing");
            this.$emit("cancel");
        },
    },
    computed: {
        ...mapGetters({
            shouldSelectPlan: "setting/shouldSelectPlan",
        }),
    },
};
</script>
<style lang="scss" scoped>
.limited-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    .alert-icon {
        font-size: 42px;
        color: rgb(250, 102, 102);
    }

    &-title {
        font-size: medium;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    &-description {
        display: flex;
        flex-direction: column;
        gap: 10px;

        &-text {
            font-size: 16px;
        }

        &-content {
            font-size: 14px;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .information-detail {
                &-text {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    &-items {
                        display: flex;
                        flex-direction: column;
                        gap: 5px;
                    }
                }
            }
        }
    }

    &-footer {
        display: flex;
        flex-direction: column;
        gap: 15px;
        align-items: center;
    }
}
</style>
